<template>
  <div>
    <b-row>
      <b-container class="content" :key="model.params.packageType">
        <b-overlay :show="searchIsRunning" rounded="sm">
          <!-- <b-row class="mb-3" v-if="model.params.packageType === 'package'">
            <b-col>
              <img src="@/assets/images/backgrounds/packages.jpg" alt="packages" class="img-fluid" />
            </b-col>
          </b-row>
          <b-row class="mb-3" v-else>
            <b-col>
              <img src="@/assets/images/backgrounds/tours.jpg" alt="tours" class="img-fluid" />
            </b-col>
          </b-row>
          Search view -->
          <SearchForm
            :params="model.params"
            :key="'searchFormFor' + model.params.packageType"
            @search="onSearch"
          ></SearchForm>
        </b-overlay>
        <template v-if="!searchIsRunning && model.params.done">
          <div class="mt-3 mt-sm-5 result-summary bg-ligth-brown p-2 py-1" no-body v-if="model.params.done">
            <b-row class="align-items-center">
              <b-col md="7">
                <SearchResultsSummary :params="model.params" results="model.results"/>
              </b-col>
              <b-col md="5">
                <SortFields @sort="onSort" @pagination="onPaginate"/>
              </b-col>
            </b-row>
          </div>
          <Legend v-if="model.results.length" />
          <template v-if="model.results.length">
            <HotelResult
              v-for="(result,resultIndex) in paginatedResults"
              :result="result"
              :params="model.params"
              :key="'result' + resultIndex"
              :selected="isSelected(result)"
              :expanded="resultIndex === 0"
              @info="onInfo([result])"
              @toggle="onToggle(result)"
              >
                <PackageResult
                  v-for="(pack, packIndex) in result.packages"
                  :pack="pack"
                  :resultIndex="resultIndex"
                  :currency="model.params.currency"
                  :key="'pack' + packIndex"
                  @book="onBook({ resultId: result.id, packageId: pack.id, ...$event })"
                  @priceDetails="onPriceDetails({ result, pack, ...$event })"
                  ></PackageResult>
            </HotelResult>
            <b-pagination
              v-model="currentPage"
              :totalRows="model.results.length"
              :per-page="resultsPerPage"
              @change="scrollToTop()"
              align="center"
              class="mt-4"
              />
          </template>
        </template>
      </b-container>
    </b-row>
    <SelectedResults
      :results="selectedResults"
      v-show="selectedResults.length"
      @hide="onHideSelected()"
      @info="onInfoSelected()"
      />
    <b-modal v-model="modal" title="Modal Info" size="xl" hide-header hide-footer>
      <div id="printArea">
        <ModalHeader @print="onPrint()" @download="onDownload()" @closeModal="onModalClose" />
        <div v-for="result in infoResults" :key="'detailedInfo' + result.id" class="px-4">
          <b-col sm="12" class="px-0 mb-3">
            <SearchParamsSummary :params="model.params"/>
          </b-col>
          <DetailedInfo
            :result="result"
            :currency="model.params.currency"
          ></DetailedInfo>
        </div>
      </div>
      <ModalFooter @closeModal="onModalClose" />
    </b-modal>

    <b-modal v-model="priceDetailsModal" title="Price Details" size="lg" hide-header hide-footer>
      <SimpleModalHeader @closeModal="closePriceDetailsModal" />
      <PriceDetails
        :title="priceDetailsParams.title"
        :meal="priceDetailsParams.meal"
        :discounts="priceDetailsParams.discounts"
        :paymentSchedule="priceDetailsParams.paymentSchedule"
      />
      <ModalFooter @closeModal="closePriceDetailsModal" />
    </b-modal>

  </div>
</template>

<script>
import model from './services/model'
import viewMixin from '../shared/mixins/search_views'
import SearchForm from './components/search_form'
import DetailedInfo from './components/detailed_info'
import SearchParamsSummary from './components/search_params_summary'
import SearchResultsSummary from './components/search_results_summary'
import HotelResult from '@/app/private/shared/components/hotel_result'
import PackageResult from './components/package_result'
import SelectedResults from '@/app/private/shared/components/selected_results'
import ModalFooter from '@/app/private/shared/components/modal_footer'
import ModalHeader from '@/app/private/shared/components/modal_header'
import SimpleModalHeader from '@/app/private/shared/components/simple_modal_header'
import PriceDetails from '@/app/private/shared/components/price_details'
import SortFields from '@/app/private/shared/components/sort_fields'
import Legend from '@/app/private/shared/components/legend'

import { paymentSchedule } from 'b2b-common/services/api/package'

export default {
  components: {
    SearchForm,
    SearchResultsSummary,
    HotelResult,
    PackageResult,
    DetailedInfo,
    ModalFooter,
    ModalHeader,
    SearchParamsSummary,
    SelectedResults,
    SimpleModalHeader,
    PriceDetails,
    SortFields,
    Legend
  },
  mixins: [viewMixin],
  data () {
    return {
      model,
      priceDetailsParams: {
        meal: null,
        title: null,
        discounts: [],
        paymentSchedule: []
      }
    }
  },
  methods: {
    onBook ({ resultId, packageId, categoryId, mealIndex }) {
      let pType = this.model.params.packageType
      pType = pType[0].toUpperCase() + pType.slice(1)
      const route = {
        name: 'Private/' + pType + '/Book',
        params: {
          Result: resultId,
          Package: packageId,
          Category: categoryId,
          Meal: mealIndex
        }
      }
      this.$router.push(route)
    },
    async onPriceDetails ({ result, pack, category, meal }) {
      this.priceDetailsParams.title = pack.name
      this.priceDetailsParams.meal = meal
      this.priceDetailsParams.discounts = []
      if (Array.isArray(category.discounts)) this.priceDetailsParams.discounts = this.priceDetailsParams.discounts.concat(category.discounts)
      if (Array.isArray(pack.discounts)) this.priceDetailsParams.discounts = this.priceDetailsParams.discounts.concat(pack.discounts)
      this.priceDetailsParams.paymentSchedule = await paymentSchedule({
        packageType: this.model.params.packageType,
        category: category.id,
        meal: meal.id
      })
      this.priceDetailsModal = true
    }
  }
}
</script>
